<template>
  <!-- <transition name="favorite-fade"> -->
  <Favorite
    v-if="showFavorite && product && product.status == 'AVAILABLE'"
    ref="refFav"
    :show-favorite-text="showFavoriteText"
    class="favorite-tag"
    :class="source === 'product-page' ? 'favorite-tag-product' : 'favorite-tag-pla'"
    :favorite="isFavorite"
    @favoriteClicked="onFavoriteClicked"
    data-testid="favorite"
    role="button"
    aria-label="Save product to favorites"
    tabindex="0"
  />
  <!-- </transition> -->
</template>

<script>
import Favorite from './Favorite.vue';
import useFavorite from '@/compositions/useFavorite.js';
import { ref, watch } from 'vue';

export default {
  name: 'ProductFavorite',
  components: {
    Favorite,
  },
  props: {
    showFavoriteText: Boolean,
    showFavorite: Boolean,
    source: {
      type: String,
      required: true,
      validators(value) {
        return ['product-page', 'pla-page'].includes(value);
      },
    },
    product: Object,
  },
  setup(props, context) {
    const isFavorite = ref(false);
    const refFav = ref(null);

    const {
      state: favoritesState, //
      updateFavoriteData,
      favorites,
    } = useFavorite();

    watch(
      () => props.product,
      () => {
        refreshIsFavorite();
      },
    );

    watch(
      () => ({ favoritesState }),
      () => {
        refreshIsFavorite();
      },
      { deep: true },
    );

    function refreshIsFavorite() {
      isFavorite.value = props.product && props.product.hashKey in favorites.value;
    }

    function onFavoriteClicked(value) {
      if (!props.product) {
        return;
      }

      updateFavoriteData({
        product: {
          id: props.product.hashKey,
          skuNo: props.product.skuNo,
        },
        value,
        target: refFav.value.$el,
      });

      context.emit('onAdd', props.product.hashKey);
    }

    return {
      onFavoriteClicked,
      isFavorite,
      refFav,
    };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.favorite-fade-enter-active,
.favorite-fade-leave-active {
  transition: opacity 100ms ease-out;
}

.favorite-fade-enter-from,
.favorite-fade-leave-to {
  opacity: 0;
}

.favorite-tag {
  position: absolute;
  top: var(--space-4);

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    top: 8px;
  }

  @media (max-width: calc($tablet-breakpoint - 1px)) {
    top: 12px;
  }
}

.favorite-tag-product {
  right: var(--space-2);
}

.favorite-tag-pla {
  top: 11px;
  right: 0px;
  border-radius: 50%;
  width: 25px;
  justify-content: center;
  padding: 5px 4px 4px 5px;
}
</style>
